module.exports = __webpack_public_path__ + "img/stock0.da7e93ef.png";